import { useContext } from 'react';
import {
  TypographySmallTitle,
  SectionContainer,
  ValueTypography,
  NotAssignedTypography,
} from './DocumentDetailsLeft';
import { Link } from 'react-router';
import { Typography, Stack } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { IDocumentUnscoped } from '../../../types/my-types';
import SetTargetTrainingSet from './SetTargetTrainingSet';
import RemoveTargetTrainingSet from './RemoveTargetTrainingSet';
import { AppContext } from '../../../App';

interface IDocumentDetailsLeftProps {
  documentData: IDocumentUnscoped;
}

const TargetTrainingSet = ({ documentData }: IDocumentDetailsLeftProps) => {
  const { dataPoolId } = useContext(AppContext);

  return (
    <SectionContainer>
      <TypographySmallTitle sx={{ marginBottom: '5px' }}>TARGET TRAINING SET</TypographySmallTitle>

      {documentData.target_training_set ? (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Link
            to={`/data-pools/${dataPoolId}/train/${documentData.target_training_set}/details`}
            style={{ textDecoration: 'underline', color: 'inherit' }}
            data-cy={`link-target-training-set-${documentData.target_training_set_label}`}
          >
            <ValueTypography>{documentData.target_training_set_label}</ValueTypography>
          </Link>

          <RemoveTargetTrainingSet documentData={documentData} />
        </Stack>
      ) : (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Stack direction="row" spacing={0.5} alignItems="center">
            <WarningIcon sx={{ color: 'orange', fontSize: 'small' }} />
            <NotAssignedTypography>Not Assigned</NotAssignedTypography>
          </Stack>
          <SetTargetTrainingSet documentId={documentData.id} />
        </Stack>
      )}
    </SectionContainer>
  );
};

export default TargetTrainingSet;
